import SeccionService from "@/api/services/personal/nomencladores/SeccionService"
import CampusService from "@/api/services/personal/nomencladores/CampusService"
import Vue from "vue"

const state = () => ({
    secciones: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    SECCIONES: state => {
        return state.secciones
    },
    SECCIONES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SECCIONES: (state, payload) => {
        state.secciones = payload
    },

    SET_SECCIONES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SECCION: (state, payload) => {
        state.secciones.push(payload)
    },

    UPDATE_SECCION: (state, payload) => {
        state.secciones = state.secciones.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SECCION: (state, payload) => {
        state.secciones = state.secciones.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SECCIONES: async ({ commit, state }, { campusID, filter, seccionEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await SeccionService.get({ campusID, filter, seccionEstado, ...pagination })
            if (status === 200) {
                commit("SET_SECCIONES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las secciones, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SECCIONES: async ({ commit }) => {
        try {
            let { data, status } = await SeccionService.getAll()
            if (status === 200) {
                commit("SET_SECCIONES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SECCIONES: async ({ commit }) => {
        try {
            let { data, status } = await SeccionService.getAllRecords()
            if (status === 200) {
                commit("SET_SECCIONES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las secciones, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SECCION: async ({ commit }, payload) => {
        try {
            let { data, status } = await SeccionService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SECCION", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la sección, inténtelo nuevamente"
            })
        }
    },

    LOAD_CAMPUS_DETAILS_SECCIONES: async ({ commit }, payload) => {
        try {
            let { data, status } = await CampusService.getCampusDetails(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los datos del campus proveniente, inténtelo nuevamente"
            })
        }
    },

    ADD_SECCION: async ({ commit }, payload) => {
        try {
            let { data, status } = await SeccionService.post(payload)
            if (status === 201) {
                commit("ADD_SECCION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La sección ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la sección, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SECCION: async ({ commit }, payload) => {
        try {
            let { data, status } = await SeccionService.put(payload)
            if (status === 200) {
                commit("UPDATE_SECCION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La sección ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la sección, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SECCION: async ({ commit }, payload) => {
        try {
            let { status, data } = await SeccionService.delete(payload)
            if (status === 204) {
                commit("DELETE_SECCION", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La sección ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SECCION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La sección ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido deshabilitar la sección, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
